export default "__VITE_ASSET__DT5ppA9D__"